import React from "react";
import "../../styles/PlayerWindow.css";
import closeButton from "../../assets/images/close.png";

const PlayerWindow = ({ title, onClose, children }) => {
    return (
        <div className="player-window">
            <div className="player-header">
                <span>{title}</span>
                <button onClick={onClose}>
                <img src={closeButton} alt="Close" style={{ width: "24px", height: "auto" }} />
                </button>
            </div>
            <div className="player-content">{children}</div>
        </div>
    );
};

export default PlayerWindow;